import api from '../../../libs/api';
import { useMutation } from 'react-query';

const updateFn = (data: any) => {
    return api.post('/api/LantisPageCounter/UpdateLantisPageCounter', {
        data: data,
        safe: true,
    });
};

const useUpdatePageCount = () => {
    
    const updateMutation = useMutation(updateFn);

    return { updateMutation };
};

export default useUpdatePageCount;
